import React, {useState, useEffect} from 'react';
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import Dropdown from 'react-dropdown';
import 'react-dropdown/style.css';
import axios from 'axios';
import {UsuarioContext} from '../../contexts/UsuarioContext';
import {useSessionStore} from '../../hooks/useSessionStore';

export const ModalesCategoriaServicios = (props) => {
	const [Usuario, setUsuario] = useSessionStore(UsuarioContext);

	const {
		nombreEmpresa,
		setNombreEmpresa,
		Categorias,
		setCategorias,
		Servicios,
		setServicios,
		reDefinirCategorias,
		CategoriasPosibles,
		definirServicios,
		ListaSuperCategorias,
		ListaNombreSuperCategorias,
	} = props;

	const [SuperCategoria, setSuperCategoria] = useState('');
	const [NombreCategoria, setnombreCategoria] = useState({
		nombre: '',
		superCategoria: '',
	});
	const [NombreServicio, setNombreServicio] = useState({
		categoria: '',
		nombreServicio: '',
	});
	/* A hook that is used to set the state of the component. */
	const [ListaCategorias, setListaCategorias] = useState([]);

	useEffect(() => {
		let listaAxu = [];
		axios({
			method: 'get',
			url: window.ipdirection + 'categoria/',
			headers: {
				Authorization: 'Bearer ' + Usuario.access,
			},
		}).then((response) => {
			response.data.map((categoria) => {
				listaAxu.push(categoria.nombre);
			});
			setListaCategorias(listaAxu);
		});
	}, [Servicios, setServicios]);

	/**
	 * It adds a category to the database.
	 */
	const anadirCategoria = () => {
		// Nos aseguramos de que la categoria no es esta vacia
		if (NombreCategoria != '') {
			axios({
				method: 'post',
				url: window.ipdirection + 'categoria/',
				data: {
					nombre: NombreCategoria.nombre,
					superCategoria: NombreCategoria.superCategoria,
				},
				headers: {
					Authorization: 'Bearer ' + Usuario.access,
				},
			}).then((response) => {
				reDefinirCategorias();
				setnombreCategoria('');
				setCategorias(false);
			});
		}
	};

	/**
	 * It takes the name of the service and the category of the service, and then it makes a post
	 * request to the server with the name and the category id
	 */
	const anadirServicio = () => {
		// buscamos el id del servicio para hacer el post
		let categoria_id;
		CategoriasPosibles.map((categoria) => {
			if (categoria.nombre === NombreServicio.categoria) {
				categoria_id = categoria.id;
			}
		});
		//hacemos el post
		if (categoria_id !== undefined && NombreServicio.nombre !== '') {
			axios({
				method: 'post',
				url: window.ipdirection + 'servicioAdmin/',
				headers: {
					Authorization: 'Bearer ' + Usuario.access,
				},
				data: {
					nombre: NombreServicio.nombreServicio,
					categoria_id: categoria_id,
				},
			}).then((response) => {
				reDefinirCategorias();
				setNombreServicio({
					categoria: '',
					nombreServicio: '',
				});
				setServicios(false);
			});
		}
	};

	/**
	 * A function that closes the modal of categories and services.
	 */
	const cerrarModalCategorias = () => {
		setnombreCategoria('');
		reDefinirCategorias();
		setCategorias(false);
	};
	const cerrarModalServicios = () => {
		setNombreServicio({
			categoria: '',
			nombreServicio: '',
		});
		setServicios(false);
	};

	const handleChangeSuperCategoriaSeleccionada = (e) => {
		setSuperCategoria(e.target.value);
	};
	/**
	 * A function that is used to handle the change of the selected category and services
	 */
	const handleChangeCategoriaSeleccionada = (e) => {
		setNombreServicio({
			...NombreServicio,
			categoria: e.value,
		});
	};
	const hadleNobreServicio = (e) => {
		setNombreServicio({
			...NombreServicio,
			nombreServicio: e.target.value,
		});
	};

	const seleccionarSuperCategoria = (nombreSuperCategoria) => {
		ListaSuperCategorias.map((superCategoria) => {
			if (superCategoria.nombre === nombreSuperCategoria) {
				setnombreCategoria({
					...NombreCategoria,
					superCategoria: superCategoria.id,
				});
			}
		});
	};

	return (
		<>
			<Modal
				centered={true}
				isOpen={Servicios}
				toggle={() => cerrarModalServicios()}
			>
				<ModalHeader>
					<b> Añadir Servicio</b>
				</ModalHeader>
				<ModalBody>
					<div>
						<div className='datoFormularioUsuario'>
							<div className='labelDatoFormUsu'>
								Seleccione la categoria a la que desea añadir el servicio
							</div>
							<div style={{width: '231px'}}>
								<Dropdown
									className='miDropDown'
									options={ListaCategorias}
									onChange={(e) => handleChangeCategoriaSeleccionada(e)}
									value={NombreServicio.categoria}
									placeholder='Select an option'
								/>
							</div>
						</div>
						{NombreServicio.categoria !== '' && (
							<div className='datoFormularioUsuario'>
								<div className='labelDatoFormUsu'>
									Seleccione el nombre de la categoria
								</div>
								<div>
									<input
										style={{width: '231px'}}
										type='text'
										className='inputTextUsuario'
										placeholder={'Nombre de la Categoria'}
										value={NombreServicio.nombreServicio}
										onChange={(e) => hadleNobreServicio(e)}
									/>
								</div>
							</div>
						)}
					</div>
				</ModalBody>
				<ModalFooter>
					<div className='buttons-modal__EliminarEncuesta'>
						<div
							className='buttonB'
							onClick={() => cerrarModalServicios()}
						>
							<b>Cancelar</b>
						</div>
						<div
							className='button'
							onClick={() => anadirServicio()}
						>
							{' '}
							<b>Aceptar</b>{' '}
						</div>
					</div>
				</ModalFooter>
			</Modal>

			<Modal
				centered={true}
				isOpen={Categorias}
				toggle={() => cerrarModalCategorias()}
			>
				<ModalHeader>
					<b> Añadir Categoria </b>
				</ModalHeader>
				<ModalBody>
					<div className='datoFormularioUsuario'>
						<div className='labelDatoFormUsu'>
							Seleccione la Super Categoria a la que desea añadir el servicio
						</div>
						<div style={{width: '231px'}}>
							<Dropdown
								className='miDropDown'
								options={ListaNombreSuperCategorias}
								onChange={(e) => seleccionarSuperCategoria(e.value)}
								placeholder='Select an option'
							/>
						</div>
					</div>
					{NombreCategoria.superCategoria !== '' && (
						<div className='datoFormularioUsuario'>
							<div className='labelDatoFormUsu'>
								Seleccione el nombre de la categoria
							</div>
							<div>
								<input
									type='text'
									className='inputTextUsuario'
									placeholder={'Nombre de la Categoria'}
									value={NombreCategoria.nombre}
									onChange={(e) =>
										setnombreCategoria({
											...NombreCategoria,
											nombre: e.target.value,
										})
									}
								/>
							</div>
						</div>
					)}
				</ModalBody>
				<ModalFooter>
					<div className='buttons-modal__EliminarEncuesta'>
						<div
							className='buttonB'
							onClick={() => cerrarModalCategorias()}
						>
							<b>Cancelar</b>
						</div>
						<div
							className='button'
							onClick={() => anadirCategoria()}
						>
							<b>Aceptar</b>
						</div>
					</div>
				</ModalFooter>
			</Modal>
		</>
	);
};
